<template>
    <div
        v-if="hasGetSyncStatus"
        class="page-container"
    >
        <!-- <import-with-rule
            v-if="showImportWithRule"
            @importSuccess="onImportSuccess"
        />
        <ready-page
            v-else-if="canImport"
            @importSuccess="onImportSuccess"
        /> -->
        <import-with-rule
            v-if="showImportWithRule"
            @importSuccess="onImportSuccess"
        />
        <status-results
            v-else
            :is-org-inited="isOrgInited"
            :is-import-ing="isImportIng"
            :sync-status="syncStatus"
            :has-error="hasError"
        />
    </div>
</template>

<script>
// 根据不同状态引用不同的展示组件 页面组件放在页面本文件同级的components的目录下
import { Icon } from 'vhtml-ui';
// import { hasPackages } from '@/utils/package';
import getSyncConfig from '@/cgi/getSyncConfig';
import getContactError from '@/cgi/getContactError';
import StatusResults from './status-results';
import ImportWithRule from '../components/import-with-rule';
// import ReadyPage from './ready';
// import Back from 'src/components/back';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {
        // Back
        StatusResults,
        ImportWithRule,
        // ReadyPage,
    },
    data() {
        return {
            // 同步状态
            hasGetSyncStatus: false,
            syncStatus: 0,
            hasError: false,
            isOrgInited: false,
            isImportIng: false,
        };
    },
    computed: {
        canImport() {
            if (this.isOrgInited && !this.isImportIng && !this.hasError) {
                return true;
            }

            return false;
        },

        showImportWithRule() {
            // return this.canImport && this.showNewVersion();
            return this.canImport;
        },
    },

    created() {
        this.getSyncStatus();
    },

    methods: {
        jumpRoute(path) {
            this.$router.push(path);
        },

        getSyncStatus() {
            getSyncConfig()
                .then((res) => {
                    const { syncStatus, isOrgInited, isImportIng, hasError, code } = res;
                    this.syncStatus = syncStatus;
                    this.isOrgInited = isOrgInited;
                    this.isImportIng = isImportIng;
                    this.hasError = hasError && code === 3;
                    this.hasGetSyncStatus = true;

                    this.getContactError();
                })
                .catch((message) => {
                    this.$message.error(message || this.$t('获取同步配置错误'));
                });
        },

        getContactError() {
            if (!this.hasError) {
                getContactError().then((errData) => {
                    const { hasError, errType } = errData || {};

                    if (hasError && errType === 'params') {
                        this.hasError = true;
                    }
                });
            }
        },

        onImportSuccess() {
            this.getSyncStatus();
        },

        // showNewVersion() {
        //     return hasPackages([
        //         10003,
        //         10007,
        //         10009,
        //         10038,
        //         10051,
        //         10058,
        //         10061,
        //         10062,
        //         10067,
        //         10109,
        //         10115,
        //         10063,
        //         10064,
        //         10065,
        //         10119,
        //         10097,
        //         10098,
        //         10120,
        //     ]);
        // },
    },
};
</script>
<style lang="less">
@import '../style.less';
</style>
